export default __webpack_public_path__ + "static/media/3.e4834e10.png";